export default __webpack_public_path__ + "static/media/Clínica-Mais.301ec209.png";